import { Component, OnDestroy, OnInit } from '@angular/core';
import { SubLicenseManagementService } from './sub-license-management.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule, Location } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import {
  MatTabChangeEvent,
  MatTabsModule,
} from '@angular/material/tabs';
import { AllEventsComponent } from '../../events/all-events/all-events.component';
import { AllVideosComponent } from '../../videos/all-videos/all-videos.component';
import { RoleServiceService } from '../../../utilities/services/role-service/role-service.service';
import { ScorecardListComponent } from '../../scorecards/scorecards-list/scorecards-list.component';
import { CommonServiceService } from '../../../utilities/services/common-service/common-service.service';
import { TranslateModule } from '@ngx-translate/core';
import { SkeletonLoaderComponent } from '../../shared/skeleton-loader/skeleton-loader.component';
import { RequestTracker } from '../../../utilities/services/loading/request-tracker';
@Component({
  selector: 'stupa-sub-license-management',
  standalone: true,
  imports: [
    CommonModule,
    MatTabsModule,
    SkeletonLoaderComponent,
    AllEventsComponent,
    AllVideosComponent,
    ScorecardListComponent,
    TranslateModule,
  ],
  templateUrl: './sub-license-management.component.html',
  styleUrl: './sub-license-management.component.scss',
})
export class SubLicenseManagementComponent implements OnInit, OnDestroy {
  readonly profileLoading = new RequestTracker();
  user_role_id: any;
  profile_tab_list: any = [
    {
      name: 'Events',
    },
    {
      name: 'Videos',
    },
    {
      name: 'Live',
    },
  ];
  default_banner: string = '../../../../assets/default_sublicense_banner.png';
  user_profile_data: any = null;
  private readonly unsubscribe$ = new Subject<void>();
  tab_index: number = 1;
  selected_role: any = null;
  event_tab_index: number = 1;
  constructor(
    private readonly subLicenseManagementService: SubLicenseManagementService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly router: Router,
    private readonly roleService: RoleServiceService,
    private readonly commonService: CommonServiceService,
    private readonly location: Location,
  ) {
    this.user_role_id =
      Number.parseInt(this.activatedRoute.snapshot.params['id']) || 0;

    const tabIndexParam = Number.parseInt(
      this.activatedRoute.snapshot.params['tab_index'],
    );
    this.tab_index = Number.isNaN(tabIndexParam) ? 1 : tabIndexParam;
    this.event_tab_index =
      Number.parseInt(this.activatedRoute.snapshot.params['event_tab_index']) || 1;
  }

  ngOnInit() {
    // Get the selected role from the service
    const roleData = this.subLicenseManagementService.getSelectedRole();
    this.selected_role = roleData?.role_name || 'Back';
    this.get_user_profile_data();
    // Subscribe to route parameter changes to keep tab_index in sync
    this.activatedRoute.params
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((params: any) => {
        if (params['tab_index'] !== undefined) {
          this.tab_index = +params['tab_index'];
          this.subLicenseManagementService.setSubLicenseTabIndex(
            this.tab_index,
          );
        }
      });
    this.subLicenseManagementService.setSubLicenseTabIndex(this.tab_index);
  }

  get_user_profile_data() {
    this.subLicenseManagementService
      .getUserProfileData(this.user_role_id)
      .pipe(this.profileLoading.track(), takeUntil(this.unsubscribe$))
      .subscribe({
        next: (res: any) => {
          this.user_profile_data = res.data;
        },
        error: (error: any) => {
          
        },
        complete: () => undefined,
      });
  }

  profile_tab_change(event: MatTabChangeEvent) {
    this.tab_index = event.index + 1;
    this.event_tab_index = 1;
    this.setTabIndexToRoute();
    this.subLicenseManagementService.setSubLicenseTabIndex(this.tab_index);
  }
  setTabIndexToRoute() {
    this.router.navigate(
      [
        '/sub-licenses',
        'sub-license-management',
        this.user_role_id,
        this.tab_index,
        this.event_tab_index,
      ],
      {
        replaceUrl: true,
      },
    );
  }
  navigateToSubLicenses() {
    this.router.navigate(['sub-licenses']);
  }
  navigateTo(path: string) {
    if (this.commonService.is_login_success.value) {
      this.router.navigate([path]);
    } else {
      if (globalThis.window !== undefined) {
        sessionStorage.setItem('redirectAfterLogin', path);
        sessionStorage.setItem('redirectSource', 'sub-license');
      }
      this.commonService.login_subject.next(true);
    }
  }
  is_image(url: string) {
    if (url && (url.startsWith('http') || url.startsWith('https'))) {
      return true;
    }
    return false;
  }
  getAbbrivation(fullName: string | null | undefined): string {
    if (fullName) {
      return fullName
        .trim()
        .split(/\s+/) // split by spaces
        .map((word) => word.charAt(0).toUpperCase())
        .join('')
        .slice(0, 2);
    }

    return '';
  }
  updateEventTabIndex(event: any) {
    this.event_tab_index = event;
    this.setTabIndexToRoute();
  }
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
